<template>
  <div class="container">
    <img src="../assets/service.png" alt="" class="bg-img">
    <div class="card">
      <img src="../assets/service1.png" alt="" class="small-img">
      <div class="text-content">
        <div class="text1">1、实现动态开放课堂，增进课堂高效互动</div>
        <div class="text2">本质上是一个动态开放的系统，借助于新兴信息技术和智能化的移动学习工具和应用支撑平台，使课堂系统超越了时空限制，动态的信息互通交流，教师与学生、学生与学生之间的沟通与交流更加立体化，实现了更为开放的教室、更为开放的课堂，大大提高了课堂互动能力和效率。</div>
      </div>
    </div>
    <div class="card">
      <img src="../assets/service2.png" alt="" class="small-img">
      <div class="text-content">
        <div class="text1">2、助力个性化学习，促进合作探究学习</div>
        <div class="text2">通过课前预习测评、课中随堂测验、课后“微课”辅导，以及学生之间协商讨论、合作探究等学习方式，形成学习共同体，帮助教师准确把握每个学习者掌握知识的状况，实现对学生的个性化学习能力的评估，使老师对每一位学生的认知更清晰，有针对性地制定教学方案和实施策略。</div>
      </div>
    </div>
    <div class="card">
      <img src="../assets/service3.png" alt="" class="small-img">
      <div class="text-content">
        <div class="text1">3、提升教学机制，搭建引导性施教环境</div>
        <div class="text2">利用云平台提供的学生信息，基于动态学习测评分析和即时反馈，依靠数据科学决策，助力教师采取机智性行动，及时调整课前的教学设计，优化和改进课堂教学进程，构建有利于学生成长的引导性环境。</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'service',
    data () {
      return {

      }
    },
  }
</script>

<style scoped>
.container{
  background:rgba(246,246,246,1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 112px;
}
.bg-img{
  width: 100%;
}
.card{
  width:62.8%;
  min-height:160px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  margin-top: 17px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  padding-right:67px;
}
.small-img{
  width: 80px;
  height: 80px;
  margin-right: 31px;
}
.text1{
  font-size:18px;
  font-weight:bold;
  color:rgba(17,17,17,1);
}
.text2{
  font-size:14px;
  font-weight:400;
  color:rgba(17,17,17,1);
}
</style>



// WEBPACK FOOTER //
// src/components/service.vue